<!-- <mc-loading [overlay]="true" [fixed]="true" *ngIf="createLoading$ | async"></mc-loading> -->
<div class="dialog-box">
    <!-- header modal -->
    <div class="mb-1 d-flex justify-content-start align-items-center flex-column">
        <div class="col-12">
            <p class="modal-title">{{ params.modalTitle }}</p>
        </div>

        <div class="col-12 mt-2">
            <p class="modal-subtitle">
                {{ params.modalSubtitle }}
            </p>
        </div>
    </div>

    <!-- body modal -->
    <div class="no-gutters mb-1">
        <div class="dialog-box flex-column flex-sm-row flex-md-column flex-lg-row p-1 pb-2">
            <form [formGroup]="contentForm" class="mb-2" *ngIf="contentForm">
                <div class="col-12 pr-2 mb-2" *ngIf="params.useTitle">
                    <div class="d-flex justify-content-between align-items-center flex-row">
                        <div>
                            <label for="name"
                                >{{ params.modalNameLabel }}
                                <span
                                    class="text-danger"
                                    *ngIf="
                                        contentForm.get('name').errors && contentForm.get('name').hasError('required')
                                    "
                                    >(*)</span
                                >
                            </label>
                        </div>

                        <div>
                            <mat-hint align="end"
                                >{{ contentForm.get('name').value.length ?? 0 }} / {{ nameMax }}</mat-hint
                            >
                        </div>
                    </div>

                    <ss-form-group-input
                        [form]="contentForm"
                        name="name"
                        type="text"
                        autocomplete="off"
                        [submitted]="showError.name"
                        (emmitFocusOut)="focusOut($event, 'name')"
                        placeholder="{{ params.modalNameHint }}"
                    >
                    </ss-form-group-input>
                </div>

                <div class="col-12 pr-2 mb-2">
                    <div class="d-flex justify-content-between align-items-center flex-row mb-2">
                        <label for="promptUsuario"
                            >{{ params.modalDescriptionLabel }}
                            <span
                                class="text-danger"
                                *ngIf="
                                    contentForm.get('promptUsuario').errors &&
                                    contentForm.get('promptUsuario').hasError('required')
                                "
                                >(*)</span
                            >
                            <br />
                            <span
                                >({{
                                    'app.global.modals.EntityIaContent.nombre_max_char'
                                        | translate : { quantity: descriptionMax }
                                }})</span
                            >
                        </label>

                        <div class="d-inline-block" ngbDropdown #dropdown="ngbDropdown">
                            <button
                                class="btn btn-skip btn-options px-3 py-1 d-flex align-items-center gap-2"
                                ngbDropdownToggle
                            >
                                {{ 'app.global.modals.EntityIaContent.tono_y_longitud' | translate }}
                                <span class="ms-auto"><i class="bi bi-chevron-down"></i></span>
                            </button>

                            <div ngbDropdownMenu class="p-3" style="width: 250px">
                                <div class="d-flex justify-content-between align-items-start flex-column">
                                    <label class="fw-bold mb-2"
                                        ><strong
                                            >{{ 'app.global.modals.EntityIaContent.tono_voz' | translate }}:</strong
                                        ></label
                                    >
                                    <div
                                        *ngFor="let tono of tonos"
                                        class="form-check d-flex justify-content-center align-items-center flex-row"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            [value]="tono.id"
                                            formControlName="tono"
                                            [id]="'tono_' + tono.id"
                                        />
                                        <label class="form-check-label fw-500" [for]="'tono_' + tono.name">
                                            {{ tono.name }}
                                        </label>
                                    </div>
                                </div>

                                <hr class="my-2" />

                                <div class="d-flex justify-content-between align-items-start flex-column">
                                    <label class="fw-bold mb-2"
                                        ><strong
                                            >{{
                                                'app.global.modals.EntityIaContent.longitud_texto' | translate
                                            }}:</strong
                                        ></label
                                    >
                                    <div
                                        *ngFor="let long of longitudes"
                                        class="form-check d-flex justify-content-center align-items-center flex-row"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            [value]="long.id"
                                            formControlName="longitud"
                                            [id]="'long_' + long.id"
                                        />
                                        <label class="form-check-label fw-500" [for]="'long_' + long">
                                            {{ long.name }}
                                        </label>
                                    </div>
                                </div>

                                <!-- Botón aplicar -->
                                <div class="d-flex justify-content-end mt-3">
                                    <button
                                        type="button"
                                        class="btn btn-skip btn-sm align-self-end"
                                        (click)="closeDropdown(dropdown)"
                                        [disabled]="
                                            !contentForm.get('tono')?.value || !contentForm.get('longitud')?.value
                                        "
                                    >
                                        {{ 'app.global.modals.EntityIaContent.buttons.aplicar' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <textarea
                        name="description"
                        class="w-100 mr-2"
                        class.form-control-lg="size == 'lg'"
                        autocomplete="off"
                        formControlName="promptUsuario"
                        class="text-area form-control pb-4"
                        rows="10"
                        maxlength="300"
                        placeholder="{{ params.modalDescriptionHint }}"
                    ></textarea>

                    <mat-hint align="end" *ngIf="!isContentGenerated">
                        {{ contentForm.get('promptUsuario').value.length ?? 0 }} / {{ descriptionMax }}
                    </mat-hint>

                    <voice-recorder
                        (transcript)="contentForm.get('promptUsuario').setValue($event); isContentGenerated = false"
                        [showTextArea]="false"
                        [showBorders]="false"
                        style="left: 0.5rem; bottom: 1rem; position: absolute"
                        *ngIf="!isContentGenerated"
                    >
                    </voice-recorder>
                </div>

                <div class="col-12 d-flex flex-lg-row flex-column pr-2 mb-2">
                    <span>{{ 'app.global.modals.EntityIaContent.la_ia_puede' | translate }}</span>
                </div>
            </form>
        </div>
    </div>

    <!-- footer modal -->
    <div class="d-flex justify-content-between justify-content-sm-end mt-4 pb-3">
        <button class="btn btn-skip mr-0 mr-sm-4" (click)="closeDialog('')">
            {{ 'app.global.modals.EntityIaContent.buttons.cancel' | translate }}
        </button>
        <button
            class="btn btn-continue align-self-end"
            (click)="generateContent()"
            [disabled]="(createLoading$ | async) || contentForm?.invalid"
            *ngIf="!isContentGenerated"
        >
            <i class="fa-solid fa-sparkles"></i>
            <mc-loading *ngIf="createLoading$ | async" color="text-white" size="sm"></mc-loading>
            {{ 'app.global.modals.EntityIaContent.buttons.create' | translate }}
        </button>

        <button class="btn btn-continue align-self-end" (click)="setContent()" *ngIf="isContentGenerated">
            <i class="fa-solid fa-sparkles"></i>
            {{ 'app.global.modals.EntityIaContent.buttons.use' | translate }}
        </button>
    </div>
</div>
